import React, {useEffect, useState} from "react";
import Header from "../components/Header";
import {useParams, useSearchParams} from "react-router-dom";
import Footer from "../components/Footer";
import "react-datepicker/dist/react-datepicker.css";
import TicketProcessBuy from "../components/Typeform/TicketProcessBuy";
import img_top from "../assets/Blog.jpg";
import {Badge} from "react-bootstrap";

function PurchaseTicket() {
    const {id} = useParams();
    const [area, setArea] = useState(null);
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [ticket, setTicket] = useState();

    const advantage = searchParams.get("advantage"); // Ottiene il valore della query string

    useEffect(() => {
        if (typeof id === "undefined")
            return;
        fetch(global.route.ticketInfo, {
            method: 'POST',
            credentials: 'include',
            body: global.getFormData(
                {id: id}
            )
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Errore nella richiesta");
                }
                return response.json();
            })
            .then((data) => {
                setTicket(data.ticket);
                setArea(data.area);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }, [id]);

    let getTicket = () => {
        let result = [];
        result.push(<TicketProcessBuy ticket={ticket}/>)
        return result;
    }

    let getTicketInfo = () => {
        let description = null;
        if (ticket.description !== null)
            description = ticket.description;
        else if (area.full_description !== null)
            description = area.full_description;
        else if (ticket.society.description !== null)
            description = ticket.society.description;

        return <div style={{backgroundColor: "#fafafa", color: "#212121"}}>
            <div className={"container p-2"}>
                <div className={"d-flex "} style={{justifyContent: "space-between"}}>

                    <div style={{flex: 1}}>
                        <h3>{ticket.name}</h3>
                    </div>
                    <Badge bg={"success"} style={{
                        fontSize: 16,
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column"
                    }}>{ticket.price.toFixed(2)}€</Badge>
                </div>
                <b className={"orange"}>{global.getNameTicketType(ticket.type)}</b><br/>
                <span>Categoria {ticket.ticket_residence_type.name}</span><br/>

                <Badge bg="dark">Valido dal {ticket.date_start_validity}</Badge>
                <Badge style={{marginLeft: 4}} bg="dark">Valido fino al {ticket.date_end_validity}</Badge><br/>
                <div className="mt-2" dangerouslySetInnerHTML={{__html: description}}/>
            </div>
        </div>
    }

    let img_bg = img_top;
    let logo = null;
    if (area !== null) {
        if (area.image !== null) {
            img_bg = global.baseUrl + area.image;
        } else {
            img_bg = global.baseUrl + "/" + area.category.image;
        }
        if (area.logo !== null)
            logo = <div className={"logo"}><img src={global.baseUrl + area.logo}/></div>
    }
    if (area === null) {
        return (
            <div style={{backgroundColor: "#fafafa"}} className={"area-info"}>
                <Header/>
                <div className="video-section">
                    <img className="background-video" src={img_bg}/>
                    <div className="overlay-content background">
                        <div>
                            <div className={"container"}>
                                <div style={{flex: 1}}>
                                    <h1 className="title">Area</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>);
    } else {
        return (<div style={{backgroundColor: "#fafafa"}} className={"area-info"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_bg}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                {logo}
                                <h1 className="title">{area.name}</h1>
                                <span>{area.address}, {area.number} {area.city} ({area.province})</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{backgroundColor: "#EEEEEE"}}>
                {getTicketInfo()}
                <div className="container pt-4 pb-4">
                    <div className="row">
                        {getTicket()}
                    </div>
                </div>
            </div>
            <Footer/>
        </div>);
    }
}

export default PurchaseTicket;